import { z } from 'zod';

export const USER_EVENTS = {
  RegisteredForAuction: 'registered_for_auction',
  AuctionRegistrationApproved: 'auction_registration_approved',
  AuctionRegistrationRejected: 'auction_registration_rejected',
  UpdatedMaxBid: 'updated_max_bid',
} as const;

export const UserEventEnum = z.nativeEnum(USER_EVENTS);

export const UserEventSchemas = {
  [USER_EVENTS.AuctionRegistrationApproved]: z.object({
    auctionId: z.string(),
  }),
  [USER_EVENTS.AuctionRegistrationRejected]: z.object({
    auctionId: z.string(),
  }),
  [USER_EVENTS.RegisteredForAuction]: z.object({
    auctionId: z.string(),
  }),
  [USER_EVENTS.UpdatedMaxBid]: z.object({
    auctionId: z.string(),
  }),
} as const;
export type UserEventPayloads = {
  [K in keyof typeof USER_EVENTS]: z.infer<(typeof UserEventSchemas)[(typeof USER_EVENTS)[K]]>;
};

type ValidatedUserEvent = {
  [K in keyof typeof USER_EVENTS]: {
    event: (typeof USER_EVENTS)[K];
    data: UserEventPayloads[K];
  };
}[keyof typeof USER_EVENTS];
export function validateUserEvent(payload: { event: string; data: unknown }): ValidatedUserEvent {
  const parsedPayload = z
    .object({
      event: UserEventEnum,
      data: z.unknown(),
    })
    .parse(payload);

  const schema = UserEventSchemas[parsedPayload.event];
  const parsedData = schema.parse(parsedPayload.data);

  return {
    event: parsedPayload.event,
    data: parsedData,
  } as ValidatedUserEvent;
}
